export const createClusterTemplate = () => {
	const clusterTemplate = ymaps.templateLayoutFactory.createClass(
		`<div class="cluster-icon">{{ properties.geoObjects.length }}</div>`,
		{
			build: function () {
				clusterTemplate.superclass.build.call(this);
				
				const size = this.getData().features.length >= 10 ? 48: 32;
				const shapeCoordinates = [
					[-size / 2, -size],
					[size / 2, 0]
				];
				const shapeRectangle = {
					type: `Rectangle`,
					coordinates: shapeCoordinates,
				};

				this.getElement().firstChild.style.transform = `translate(-50%,-100%)`;
				this.getElement().firstChild.style.width = `${size}px`;
				this.getElement().firstChild.style.height = `${size}px`;
				
				this.getData().options.set(`shape`, shapeRectangle);
			}
		}
	);
	
	return clusterTemplate;
};
